export default __webpack_public_path__ + "static/media/pay-bg.e673e041.jpg";